import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface MtFormButtonsActions {
  onCancelClick?: MouseEventHandler;
  onPreviousClick?: MouseEventHandler;
  onNextClick?: MouseEventHandler;
  onSubmitClick?: MouseEventHandler;
}

export interface MtFormButtonsData {
  showCancel?: boolean;
  showPrevious?: boolean;
  showNext?: boolean;
  showSubmit?: boolean;
  cancelDisabled?: boolean;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  submitDisabled?: boolean;
  cancelLoading?: boolean;
  previousLoading?: boolean;
  nextLoading?: boolean;
  submitLoading?: boolean;
  sticky?: boolean;
}

export interface MtFormButtonsProps
  extends MtFormButtonsData,
    MtFormButtonsActions,
    HTMLAttributes<HTMLDivElement> {}
